// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  postWrapper,
} from 'helpers/api'

export const postGetCallsignCascades = body => (
  postWrapper('/call-sign-cascades/find-matches', body)
)

export const postPerformGroup2CallSignCascade = body => (
  postWrapper('/call-sign-cascades', body)
)
